import React, {useEffect, useCallback} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {logPageLoadEvents} from '@ibibo/analytics';

import {
  fetchRefundData,

  myTripDetailsParamsSelector,
  activeCancellationTabSelector,
  cancellationDataSelector,
  selectedRefundModeSelector,
  cancellationRefundBreakupDataSelector,
} from '@ibibo/myaccount-reducer';

import * as S from '../CancelFlow/CancelFlow.styles';

import CancelLeftBlock from '../../../stories/components/CancelFlow/CancelLeftBlock/CancelLeftBlock';
import CancelRightBlock from '../../../stories/components/CancelFlow/CancelRightBlock/CancelRightBlock';

const RefundBreakup = () => {
  const detailsParams = useSelector(myTripDetailsParamsSelector);
  const activeTab = useSelector(activeCancellationTabSelector);
  const refundData = useSelector(cancellationDataSelector);
  const selectedRefundMode = useSelector(selectedRefundModeSelector);
  const refundBreakUp = useSelector(cancellationRefundBreakupDataSelector);


  const {
    ivr_msg,
    cp_list = [],
    fb_list = [],
    ra_list = [],
    refund_breakup = [],
    hotel_name = '',
    image,
    rating = '',
    travel_start_datetime,
    travel_end_datetime,
    rooms,
    room_type,
    fcdt,
    success,
    message
  } = refundData;

  const hotelDetails = {
    hotelName: hotel_name,
    image,
    checkin: travel_start_datetime ? new Date(travel_start_datetime) : '',
    checkout: travel_end_datetime ? new Date(travel_end_datetime) : '',
    rating,
    rooms,
    roomType: room_type
  };

  const breakupList = {
    cp_list,
    fb_list,
    ra_list
  }

  const freeCancellationText = fcdt ? `Your booking is freely cancellable till ${fcdt}` : '';

  const dispatch = useDispatch();

  const fetchRefundDetailsDataCaller = useCallback(() => {
    return dispatch(fetchRefundData(detailsParams));
  }, [dispatch]);

  useEffect(() => {
    fetchRefundDetailsDataCaller();
  }, []);

  useEffect(() => {
    if(refundData && refundData.hotel_country_name){
      let searchType = 'domestic';
      if(refundData.hotel_country_name !== "india"){
        searchType = 'intl';
      }
      logPageLoadEvents(`postbooking:${searchType} hotels mybookings:refundbreakup`, {});
    }
  }, [refundData]);

  return(
    <S.CancelMainWrapper>
      <S.CancelOuterWrap>
        <CancelLeftBlock
          headerText="Refund Breakup"
          header={ivr_msg || message || ''}
          showTabs={false}
          selectedRefundMode={selectedRefundMode}
          activeTab={activeTab}
          updateActiveTab={() => {}}
          breakupList={breakupList}
          freeCancellationText={freeCancellationText}
          updateRefundMode={() => {}}
          refundBreakUp={refundBreakUp}
          hotelDetails={hotelDetails}
          confirmCancellation={() => {}}
          showPayModeButton={false}
        />
        {(success && <CancelRightBlock hotelDetails={hotelDetails} refundBreakup={refund_breakup} />) || null}
      </S.CancelOuterWrap>
    </S.CancelMainWrapper>  
  );
}

export default RefundBreakup;